export default "__VITE_ASSET__7d86ae1c__"